/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWochenplanZuordnungDto } from '../../models/create-wochenplan-zuordnung-dto';
import { KalendereintragDto } from '../../models/kalendereintrag-dto';

export interface CreateWochenplanZuordnungForMitarbeiter$Plain$Params {
  mitarbeiterId: string;
      body?: CreateWochenplanZuordnungDto
}

export function createWochenplanZuordnungForMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: CreateWochenplanZuordnungForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KalendereintragDto>>> {
  const rb = new RequestBuilder(rootUrl, createWochenplanZuordnungForMitarbeiter$Plain.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KalendereintragDto>>;
    })
  );
}

createWochenplanZuordnungForMitarbeiter$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/wochenplaene';
